<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 자료구분 -->
          <c-select
            :comboItems="comboDocumentTypeItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            name="ramDocumentTypeCd"
            label="자료구분"
            v-model="searchParam.ramDocumentTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="관련자료 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      @rowDblclick="rowDblclick"
      :selection="popupParam.type"
      rowKey="documentId"
    >
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'documentTitle'">
          <!-- 상세보기가 있는 자료구분만 링크 표시 -->
          <q-btn
            v-if="hasDetail(props.row)"
            class="tableinnerBtn tableinnerBtn-left"
            align="left"
            flat
            color="blue-6"
            :label="props.row.documentTitle"
            @click.stop="linkClick(props.row)"
          />
          <span v-else>{{ props.row.documentTitle }}</span>
          <div v-if="props.row.documentSubTitle" class="description-td">
            {{ props.row.documentSubTitle }}
          </div>
        </template>
      </template>
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn v-if="editable" label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'kras-relation-docu',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'multiple',
        }
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'ramDocumentTypeName',
            field: 'ramDocumentTypeName',
            label: 'LBLCLASSIFICATION',
            align: 'center',
            style: 'width:50%',
            sortable: false,
          },
          {
            name: 'documentTitle',
            field: 'documentTitle',
            label: 'LBLTITLE',
            align: 'left',
            style: 'width:50%',
            sortable: false,
            type: 'custom',
          },
        ],
        data: [],
        height: '650px'
      },
      searchParam: {
        plantCd: null,
        ramDocumentTypeCd: null,
      },
      comboDocumentTypeItems: [],
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.relatedDocument.addData.url;
      // code setting
      this.$comm.getComboItems('RAM_DOCUMENT_TYPE_CD').then(_result => {
        this.comboDocumentTypeItems = this.$_.reject(_result, { code: 'RDT0000020' })
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '하나 이상 선택하세요', // 사용자를 먼저 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    hasDetail(row) {
      return Boolean(row.documentId) && Boolean(this.getDetailInfo(row));
    },
    getDetailInfo(row) {
      // 자료구분별 상세화면
      let detail = null;
      switch (row.ramDocumentTypeCd) {
        case 'RDT0000001': // 공정안전자료(도면)
          detail = {
            title: '도면 상세',
            param: { psiDiagramId: row.documentId },
            target: () => import(`${'@/pages/psi/pidMasterDetail.vue'}`),
          };
          break;
        case 'RDT0000010': // 공정사고
          detail = {
            title: '안전사고 상세',
            param: { iimAccidentId: row.documentId, stepCd: '', count: 0 },
            target: () => import(`${'@/pages/sop/iim/processAccidentDetail.vue'}`),
          };
          break;
        case 'RDT0000015': // 아차사고
          detail = {
            title: '아차사고 상세',
            param: { iimNearAccidentId: row.documentId },
            target: () => import(`${'@/pages/sop/iim/near/nearAccidentDetail.vue'}`),
          };
          break;
        case 'RDT0000025': // 근골격계 조사계획
          detail = {
            title: '근골격계 조사계획',
            param: { heaInvestigationPlanId: row.documentId },
            target: () => import(`${'@/pages/hea/mss/investigationPlanDetail.vue'}`),
          };
          break;
        default:
          break;
      }
      return detail;
    },
    linkClick(row) {
      let detail = this.getDetailInfo(row);
      if (!detail) return;
      this.popupOptions.title = detail.title;
      this.popupOptions.param = detail.param;
      this.popupOptions.target = detail.target;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDetailPopup;
    },
    closeDetailPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
